import React, { Fragment, useContext } from "react";
import ToggleSwitch from "./ToggleSwitch";
import DataTable from "react-data-table-component";
import { mmtColumns } from "../../Data/Configuration/MMT";
import { Spinner } from "../../AbstractElements";
import CustomizerContext from "../../_helper/Customizer";

const MMTConfigurationTable = ({
  tableData,
  setShowApiLoader,
  fetchTableData,
  paginationPerPage,
  paginationTotalRows,
  onChangePage,
  onChangeRowsPerPage,
  loader
}) => {
  const {mix_background_layout} = useContext(CustomizerContext)
  const processData = tableData.map((element, index) => {
    return {
      city: element.city ? element.city : "-",
      companyName: element.companyName ? element.companyName : "-",
      companyId: element.id,
      A2C: (
        <ToggleSwitch
          key={index + "A2C"}
          setShowApiLoader={setShowApiLoader}
          isChecked={element.a2c}
          companyId={element.id}
          index={index}
          fetchTableData={fetchTableData}
          type="A2C"
        />
      ),
      C2A: (
        <ToggleSwitch
          key={index + "C2A"}
          setShowApiLoader={setShowApiLoader}
          isChecked={element.c2a}
          companyId={element.id}
          index={index}
          fetchTableData={fetchTableData}
          type="C2A"
        />
      ),
    };
  });
  return (
    <Fragment>
      <div className="table-responsive mmt-config">
        <DataTable
          columns={mmtColumns}
          data={processData}
          center={true}
          fixedHeader
          fixedHeaderScrollHeight={"57vh"}
          pagination
          paginationPerPage={paginationPerPage}
          paginationTotalRows={paginationTotalRows}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          // customStyles={customStyles}
          paginationServer
          progressPending={loader}
          progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
              <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
          </div>}
          theme={mix_background_layout == "dark-only" ? "dark" : "default"}
        />
      </div>
    </Fragment>
  );
};

export default MMTConfigurationTable;
